import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { userSlice }       from './slices/userSlice'
import { goalSlice }       from './slices/goalSlice'
import { reviewSlice }     from './slices/reviewSlice'
import { unlockSlice, constraintSlice, timelineSlice } from './slices/otherSlices'

export const useStore = create(
  devtools(
    (set, get) => ({
      ...userSlice(set, get),
      ...goalSlice(set, get),
      ...reviewSlice(set, get),
      ...unlockSlice(set, get),
      ...constraintSlice(set, get),
      ...timelineSlice(set, get),

      // ── Bootstrap called once on app start ──────────────────────────────────
      _booted: false,
      boot: async () => {
        if (get()._booted) return   // idempotent — safe to call multiple times
        await get().initAuth()
        if (!get().user) { set({ _booted: true }); return }
        await Promise.all([
          get().loadAll(),
          get().loadUnlocks(),
          get().loadReviews(),
        ])
        get().recompute()
        get().checkReviewDue()
        await get().checkUnlocks()
        set({ _booted: true })
      },

      // ── Called after any goal mutation ────────────────────────────────────
      afterMutation: async () => {
        get().recompute()
        await get().checkUnlocks()
      },
    }),
    { name: 'Mori' }
  )
)

export default useStore
